export const formatAddress = (value?: {
  address: string
  city: string
  region: string
  zipCode: string
}) => {
  return [value?.address, value?.city, value?.region, value?.zipCode].filter(Boolean).join(', ')
}

export const formatVehicleInfo = (value?: {
  year: number
  make: string
  model: string
  licensePlate: string
}): string => {
  return [value?.year, value?.make, value?.model, value?.licensePlate].filter(Boolean).join(' / ')
}
